var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dateValue)?_c('div',{staticClass:"integration-created-date-table-cell"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }